import { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import Ripple from "../ui/spinners/ripple/Ripple";
import Swiper from "../Swiper/Swiper";
import SwiperSlide from "../Swiper/SwiperSlide/SwiperSlide";
import ProductCard from "../ProductListing/ProductsGrid/ProductCard/ProductCard";
import classes from "./SkusSlider.module.css";

const SkusSlider = (props) => {
  const { className, isLoading, skus, title } = props;
  const skusSliderRef = useRef();

  useEffect(() => {
    if (skusSliderRef.current) {
      const { width } = skusSliderRef.current.getBoundingClientRect();
      skusSliderRef.current.style.setProperty("--slider-width", `${width}px`);
    }
  }, []);

  return (
    <section
      className={classNames(classes["skus-slider"], className)}
      ref={skusSliderRef}
    >
      {isLoading ? (
        <Ripple className="border-dark-blue" />
      ) : (
        skus.length > 0 && (
          <div className={classes["skus-slider__swiper-container"]}>
            <h2 className={classes["skus-slider__title"]}>{title}</h2>
            <Swiper
              className={classes["skus-slider__swiper"]}
              paginationClassName={classes["skus-slider__swiper-pagination"]}
              numberOfSlides={skus.length}
              spaceBetween={50}
              breakpoints={{
                0: {
                  slidesPerView: 2,
                },
                1024: {
                  slidesPerView: 3,
                },
                1280: {
                  slidesPerView: 4,
                },
              }}
            >
              {skus.map((sku, index) => (
                <SwiperSlide
                  key={index}
                  className={classes["skus-slider__swiper-slide"]}
                  lazy={isLoading}
                >
                  <ProductCard sku={sku} />
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        )
      )}
    </section>
  );
};

export default SkusSlider;

SkusSlider.propTypes = {
  className: PropTypes.string,
  isLoading: PropTypes.bool,
  title: PropTypes.string,
  skus: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      commercialName: PropTypes.string,
      skuBrand: PropTypes.string,
      suggestedSellingPrice: PropTypes.number,
      quantity: PropTypes.number,
      imageUrl: PropTypes.string,
    })
  ),
};
